import {
  ArrowRight,
  ArrowUpRight,
  BarChart3,
  Blocks,
  Boxes,
  BrainCircuit,
  Building2,
  Calculator,
  Check,
  Clock,
  Cog,
  Compass,
  Factory,
  FileSearch,
  GraduationCap,
  HandCoins,
  Handshake,
  HardHat,
  Headset,
  KanbanSquare,
  Landmark,
  LayoutGrid,
  Lightbulb,
  ListOrdered,
  Mail,
  MapPin,
  Palette,
  Phone,
  Receipt,
  School,
  Search,
  ServerCog,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Store,
  TrendingUp,
  Truck,
  Wallet,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

/**
 * Registre explicite des icônes.
 *
 * Volontairement fermé : le back-office choisit une icône dans cette liste,
 * ce qui évite d'embarquer les 6 000 icônes de Lucide dans le bundle et garantit
 * qu'aucune icône inconnue ne casse une page.
 */
const ICONS = {
  ArrowRight,
  ArrowUpRight,
  BarChart3,
  Blocks,
  Boxes,
  BrainCircuit,
  Building2,
  Calculator,
  Check,
  Clock,
  Cog,
  Compass,
  Factory,
  FileSearch,
  GraduationCap,
  HandCoins,
  Handshake,
  HardHat,
  Headset,
  KanbanSquare,
  Landmark,
  LayoutGrid,
  Lightbulb,
  ListOrdered,
  Mail,
  MapPin,
  Palette,
  Phone,
  Receipt,
  School,
  Search,
  ServerCog,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Store,
  TrendingUp,
  Truck,
  Wallet,
  Wrench,
} satisfies Record<string, LucideIcon>

export type IconName = keyof typeof ICONS

export const ICON_NAMES = Object.keys(ICONS) as IconName[]

interface IconProps {
  name: string | undefined
  className?: string
  strokeWidth?: number
}

/** Rend une icône par son nom. Un nom inconnu ne rend rien (jamais d'erreur). */
export function Icon({ name, className, strokeWidth = 1.75 }: IconProps) {
  if (!name || !(name in ICONS)) return null
  const Component = ICONS[name as IconName]
  return <Component className={className} strokeWidth={strokeWidth} aria-hidden="true" />
}
